/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { EventProvider } from "./context/EventContext";
import { Toaster } from "./components/ui/sonner";
import { router } from "./router";
import "./index.css";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <EventProvider>
      <RouterProvider router={router} />
      <Toaster />
    </EventProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
